import { usePrenuvoStore } from '@/stores/usePrenuvoStore';
import { Slot } from '@/types';
import { retrieveFormattedSlotHour } from '@/utils/slotCalendarFunctions';
import { useShallow } from 'zustand/react/shallow';

export const useAvailabilitySlot = (slot: Slot) => {
  const { currentSlot, location } = usePrenuvoStore(
    useShallow((state) => ({
      currentSlot: state.scan.slot,
      location: state.scan.location,
    })),
  );

  const getSlotBoxesClassNames = (isSelectedSlot: boolean) => {
    if (isSelectedSlot) return 'rounded-lg cursor-pointer bg-blue-50';
    return 'bg-neutral-100 hover:bg-geyser-300 rounded-lg cursor-pointer';
  };

  const isSelectedSlot = slot?.utcStart === currentSlot?.utcStart;
  const isActive =
    isSelectedSlot &&
    slot.machines.some((machine: string) => currentSlot?.machines.includes(machine));
  const classNames = getSlotBoxesClassNames(isSelectedSlot);
  const time = retrieveFormattedSlotHour(slot, location?.timezone || '');
  const machineCount = slot?.machines.length;

  return { isActive, classNames, machineCount, time };
};
